import { Component, OnDestroy, OnInit } from '@angular/core';
import { DispositivoService } from '../../../services/dispositivo.service';
import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { environment } from '../../../../environments/environment';
import { DadosCalculadoraService } from '../../../services/dados-calculadora.service';
import { VersaoService } from '../../../services/versao.service';
import { AvailableBSPositions } from 'ngx-bootstrap/positioning';

@Component({
  selector: 'my-version',
  templateUrl: './my-version.component.html',
  styleUrl: './my-version.component.scss',
  standalone: true,
  imports: [
    CommonModule,
    TooltipModule
  ],
})
export class MyVersionComponent implements OnInit, OnDestroy {

  private subscriptions: Subscription = new Subscription();
  
  dispositivo: string = '';

  resposta: any = null;

  versaoExecucao: any = null;
  versaoStatusOffline: boolean = false;
  versaoProblema: boolean = false;
  versaoTooltip: string = 'Informações sobre a versão do aplicativo em execução';

  placement: AvailableBSPositions = 'top';

  constructor(
    private dispositivoService: DispositivoService,
    private versaoService: VersaoService,
    private dadosCalculadoraService: DadosCalculadoraService
  ) { }

  ngOnInit(): void {

    this.versaoService.obterVersao().subscribe({
      next: (resposta) => {
        this.versaoExecucao = resposta;
        this.dadosCalculadoraService.versaoExecucao = this.versaoExecucao;
      },
      error: (error) => {
        console.error('Erro ao obter a versão:', error);
      }
    });

    if (environment.profile === 'offline' || (window as any).environment?.profile === 'offline') {
      this.versaoService.obterStatusVersaoOffline().subscribe({
        next: (status) => {
          this.versaoStatusOffline = status;
          this.versaoProblema = !status.aplicacaoAtualizada || !status.dbAtualizada;
          if (!status.aplicacaoAtualizada || !status.dbAtualizada) {
            this.versaoTooltip = this.montarMensagemTooltip(status);
          }
        },
        error: (error) => {
          console.error('Erro ao obter status da versão offline:', error);
          this.versaoProblema = true;
          this.versaoTooltip = 'Erro ao verificar status da versão offline';
        }
      });
    }

    this.setSubscriptions();
  }
  
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  setPlacement() {
    if (this.dispositivo === 'device-xsmall') {
      this.placement = 'top right';
    } else if (this.dispositivo === 'device-small' || this.dispositivo === 'device-medium') {
      this.placement = 'top right';
    } else if (this.dispositivo === 'device-large' || this.dispositivo === 'device-xlarge') {
      this.placement = 'top';
    } else {
      this.placement = 'top';
    }
  }

  setSubscriptions() {
    this.subscriptions.add(
      this.dispositivoService.dispositivo$.subscribe((dispositivo) => {
        this.dispositivo = dispositivo;
        this.setPlacement();
      })
    );
  }

  montarMensagemTooltip(status: any): string {
    let msg = '';
    if (!status.aplicacaoAtualizada) {
      msg += 'A aplicação local está desatualizada. ';
    }
    if (!status.dbAtualizada) {
      msg += 'O banco de dados local está desatualizado. ';
    }
    return msg || 'Tudo atualizado!';
  }

}
